<template>
<svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_518_88)">
<path d="M23.5 0H0V19H23.5V0Z" fill="#F4C600" stroke="black" stroke-opacity="0.01"/>
<path d="M11.2 10L0 1H24L11.2 10Z" fill="black"/>
</g>
<defs>
<clipPath id="clip0_518_88">
<rect width="24" height="19" fill="white"/>
</clipPath>
</defs>
</svg>
</template>
